export enum CheckpointStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PUBLIC = "PUBLIC",
  ADMIN_ONLY = "ADMIN_ONLY",
  FAILED = "FAILED",
  PASSED = "PASSED",
}
